export default __webpack_public_path__ + "asset/img/checkbox-unsel~c15bc044.png";